<template lang="pug">
v-container.user-info
  base-text-divider 會員資料
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 姓名：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2 {{ user.displayName }}
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 編號：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2 {{ user.number }}
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 職稱：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2(v-for="job in user.jobs") {{ job || '-' }}
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 地區：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2 {{ user.region | regionFilter }}
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 會員類別：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2 {{ user.plan | planFilter }}
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 性別：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2 {{ user.gender | genderFilter }}
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 職業：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2 {{ user.career || '-' }}
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 家鄉：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2 {{ user.homeland || '-' }}
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 生日：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2 {{ user.birth | timestampFilter }}
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 電子信箱：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2 {{ user.email || '-' }}
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 職業：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2 {{ user.career || '-' }}
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 電話：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2 {{ user.phoneNumber || '-' }}
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 電話2：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2 {{ user.phoneNumber_2 || '-' }}
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 地址：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2 {{ user.address }}
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 郵遞區號：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2 {{ user.zipCode }}
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 推薦人：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2 {{ user.referrer || '-' }}
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 備註：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2 {{ user.remarks || '-' }}
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 衣服尺寸：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2 {{ user.tshirtSize || '-' }}
  v-layout
    v-flex(
      xs5
      sm6)
      .text-xs-right.pa-2 隱藏：
    v-flex(
      xs7
      sm6)
      .text-xs-left.pa-2 {{ user.hide ? '是' : '否' }}
  base-text-divider 最新年度繳費資料
  v-layout(
    v-if="hasLastYearReceipt"
    justify-center)
    v-flex.text-xs-center(
      v-for="item in user.lastYearReceipts"
      xs4)
      receipt-item-chip(
        :year="item.year"
        :text="item | receiptItemFilter")
  v-layout(
    v-else
    justify-center)
    v-flex.text-xs-center(xs12)
      p 無繳費資料
</template>
<script>
import BaseTextDivider from "@/components/core/BaseTextDivider.vue";
import ReceiptItemChip from "@/components/core/ReceiptItemChip.vue";

export default {
  name: "UserInfo",
  components: {
    BaseTextDivider,
    ReceiptItemChip
  },
  props: {
    user: {
      type: Object,
      require: true
    }
  },
  computed: {
    hasLastYearReceipt() {
      return this.user.lastYearReceipts
        ? this.user.lastYearReceipts.length > 0
        : false;
    }
  }
};
</script>
